import { request, gql } from 'graphql-request';

import { getConfig } from '@app/config';
import { Tick } from '@app/types/tick';

function getQuery() {
  return gql`
    query allTicks($poolAddress: String!, $skip: Int!) {
      ticks(
        first: 1000
        skip: $skip
        where: { poolAddress: $poolAddress }
        orderBy: tickIdx
      ) {
        tickIdx
        liquidityNet
        liquidityGross
        price0
        price1
      }
    }
  `;
}

export const fetcher = async (
  poolAddress: string,
  skip: number,
  chainId: number | undefined
) => {
  if (!chainId) {
    return;
  }

  const query = getQuery();

  const res = await request<{ ticks: Tick[] }>(
    `${getConfig(chainId)?.URLS.subgraphUrlV3}`,
    query,
    {
      poolAddress,
      skip
    }
  );

  return res;
};
